import { SetStateAction, useState } from 'react';
import CitiesSorting from './CitySorting';
import ReviewsSorting from './ReviewsSorting';

interface IProps {
  cityFilter: Record<string, any>;
  setCityFilter: React.Dispatch<React.SetStateAction<
    Record<string, any>
  > | null>;
  sortOrder: string;
  setSortOrder: React.Dispatch<React.SetStateAction<string>>;
  citiesDropdown: Record<string, any>[] | undefined;
  citiesToggle: boolean;
  setCitiesToggle: React.Dispatch<SetStateAction<boolean>>;
  sortToggle: boolean;
  setSortToggle: React.Dispatch<SetStateAction<boolean>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<SetStateAction<number>>;
}
const ReviewsFilterNav = ({
  cityFilter,
  setCityFilter,
  sortOrder,
  setSortOrder,
  citiesDropdown,
  citiesToggle,
  setCitiesToggle,
  sortToggle,
  setSortToggle,
  currentPage,
  setCurrentPage
}: IProps) => {
  const [city, setCity] = useState<string | undefined>();

  return (
    <section id="reviews filter" className="mt-5 bg-[#F1F1F1]">
      <div className="flex lg:w-[85%] xsm:w-[95%] py-6  mx-auto justify-between px-3 xsm:px-8 sm:px-16 ">
        <CitiesSorting
          cityFilter={cityFilter}
          setCityFilter={setCityFilter}
          citiesDropdown={citiesDropdown}
          city={city}
          setCity={setCity}
          citiesToggle={citiesToggle}
          setCitiesToggle={setCitiesToggle}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
        <ReviewsSorting
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          sortToggle={sortToggle}
          setSortToggle={setSortToggle}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </section>
  );
};

export default ReviewsFilterNav;
